import { createError } from '@common/neo.tax';
import { useContext } from 'react';

import { AscContextValue } from '../asc-context-provider.types';
import { AscContext } from '../AscContextProvider';

export const useAscContext = (): AscContextValue => {
  const { fiscalYear, fiscalYearId, period, periodName, product } = useContext(AscContext);
  if (!period || !fiscalYearId || !fiscalYear || !periodName || !product) {
    throw createError('UseAscContextError', 'No asc context found');
  }
  return { period, fiscalYearId, fiscalYear, periodName, product };
};
